import { Button, Typography } from '@one-thd/sui-atomic-components';
import { Catalog, Clock, CustomOptions } from '@one-thd/sui-icons';
import React from 'react';

const advantages = [
  {
    icon: () => <Clock />,
    title: 'Faster, Easier Ordering',
    description:
      'Save your delivery address and card information for easy, one-step purchasing.',
  },
  {
    icon: () => <Catalog />,
    title: 'Quick Order Review',
    description:
      'Review your item selection and delivery dates before placing your order.',
  },
  {
    icon: () => <CustomOptions />,
    title: 'Change Settings Anytime',
    description: 'Adjust your saved address or card information at any time.',
  },
];

interface SetupInstantCheckoutProps {
  handleStartSetUp: () => void;
}

export const SetupInstantCheckout = ({
  handleStartSetUp,
}: SetupInstantCheckoutProps) => {
  return (
    <>
      <div className="sui-mb-8 2xl:sui-mb-8">
        <div className="sui-pb-2">
          <Typography variant="h2" weight="display">
            Save Time with Instant Checkout
          </Typography>
        </div>
        <div className="sui-pb-8">
          <Typography>
            Set up your delivery address and payment method to start express
            shopping.
          </Typography>
        </div>
        <div className="sui-w-full md:sui-w-1/2 xl:sui-w-1/6">
          <Button
            onClick={handleStartSetUp}
            fullWidth
            data-testid="instantCheckout_getStarted"
          >
            Get Started
          </Button>
        </div>
      </div>

      <ul
        className="sui-grid sui-grid-cols-9 sui-gap-5"
        data-testid="advantages"
      >
        {advantages.map((item) => (
          <li key={item.title} className="sui-col-span-9 xl:sui-col-span-3">
            <div className="sui-flex sui-items-center sui-gap-2 sui-mb-2">
              {item.icon()}
              <Typography variant="h4">{item.title}</Typography>
            </div>
            <Typography>{item.description}</Typography>
          </li>
        ))}
      </ul>
    </>
  );
};
